import containerFuild from '../html-snippets/container-fuild';
import buttonPrimaryHtml from '../../../views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/section-cedrow-section-freetype-content';

const buttonRivoneedHtml = buttonPrimaryHtml({
  text: 'Get Started',
  backgroundColor: '#ffffff',
  color: '#000000',
  radius: 8,
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a87db55a093b7ad8c6903.png',
  },
});

const html = `
<div class="container">
  <div class="wrap-card">
    <div
      data-show="true"
      data-attribute="wrap-pill"
      class="wrap-pill"
      style="
        --border-radius: 10px;
        --border-background: #ffffff33;
        --text-color-pill: #ffffff;
        --background-color-pill: #ffffff1a;
      "
    >
      <div data-attribute="pill-item" class="pill-item">
        <div class="icon">
          <img
            data-attribute="icon-pill"
            src="https://cdn.skyfastimg.com/images/2026/06/15/image-6a2fb04bed73b6428256aeef.png"
            alt=""
          />
        </div>
        <span data-attribute="content-pill" class="content">Secure support for every step</span>
      </div>
    </div>
    <div data-show="true" data-attribute="section-content" class="section-content">
      <h2 style="text-align: center">Stop toe dragging &amp; walk with confidence again<i> instantly</i></h2>
      <p style="text-align: center">&nbsp;</p>
      <p style="text-align: center">
        Foot drop, nerve weakness, or neurological conditions can make it difficult to lift the front of your foot while
        walking.
      </p>
      <p style="text-align: center">
        This causes your toes to drag,
        <strong>increases your risk of tripping, and forces you to overcompensate with your hips and knees</strong>
        leading to tiring, unstable steps and constant fear of falling.
      </p>
      <p style="text-align: center">
        Wearing a supportive foot drop brace helps keep your foot in a natural lifted position while you walk, improving
        step clearance and stability.<br /><br />This reduces stumbling risk, supports smoother movement, and helps you
        walk with greater confidence and independence throughout your day.
      </p>
    </div>
    <div data-attribute="wrap-button" class="wrap-btn-rivoneed">${buttonRivoneedHtml}</div>
  </div>
</div>
`;

export default containerFuild(html, css, {
  backgroundColor: '#00374c',
  textColor: '#ffffff',
  topPadding: true,
  bottomPadding: true,
});
